import {
  navigationDeliveryKey,
  type NavigationDeliveryEntry,
} from './navigation-delivery-store';
export const NAVIGATION_DELIVERY_STORAGE_KEY =
  'imai:navigation-delivery-failures:v1';
const record = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === 'object' && !Array.isArray(value);

export function readNavigationDeliveryFailures(
  storage: Pick<Storage, 'getItem'>
): NavigationDeliveryEntry[] {
  try {
    const parsed: unknown = JSON.parse(
      storage.getItem(NAVIGATION_DELIVERY_STORAGE_KEY) ?? '[]'
    );
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry): entry is NavigationDeliveryEntry => {
      if (!record(entry) || entry.status !== 'failed' || !record(entry.job))
        return false;
      const job = entry.job;
      return (
        [
          'id',
          'actorId',
          'orgSlug',
          'routeRef',
          'orgId',
          'title',
          'prompt',
        ].every((key) => typeof job[key] === 'string') &&
        (job.visibility === 'private' || job.visibility === 'organization') &&
        record(job.options)
      );
    });
  } catch {
    return [];
  }
}

/** Never automatically replay an in-flight operation after an uncertain reload. */
export function writeNavigationDeliveryFailures(
  storage: Pick<Storage, 'getItem' | 'setItem'>,
  entries: NavigationDeliveryEntry[]
) {
  try {
    const previous = readNavigationDeliveryFailures(storage);
    const recoverable = entries.flatMap((entry) =>
      entry.status === 'failed'
        ? [entry]
        : previous.filter(
            (saved) =>
              navigationDeliveryKey(saved.job) ===
              navigationDeliveryKey(entry.job)
          )
    );
    storage.setItem(
      NAVIGATION_DELIVERY_STORAGE_KEY,
      JSON.stringify(recoverable)
    );
  } catch {
    /* The app-owned copy remains available when browser storage is full. */
  }
}
